import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';

import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BookList from 'rebook/apps/books/components/BookList';
import CatalogHeader from 'rebook/apps/catalog/components/CatalogHeader';
import CatalogDescription from 'rebook/apps/catalog/components/CatalogDescription';
import AdaptiveImage from 'rebook/apps/utils/components/AdaptiveImage';
import BooksetAuthor from 'rebook/apps/base/components/BooksetAuthor';
import SocialShareMenu from 'rebook/apps/base/components/SocialShareMenu';
import BooksetsCarousel from 'rebook/apps/base/components/BooksetsCarousel';
import * as BooksetDetailActions from 'rebook/apps/catalog/actions/BooksetDetailActions';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';

import styles from './style.scss';


const paginateCountLong = 10;
const paginateCountShort = 18;

class BooksetDetailView extends React.Component {
  constructor() {
    super();
    this.state = {
      isDisplayLongVersion: false,
    };
    this.bookListRef = React.createRef();
  }

  static fetchInitialDataForServer(match, store) {
    const paginateBy = get(match, 'path', '').indexOf('/t/') !== -1 ? paginateCountLong : paginateCountShort;
    return store.dispatch(BooksetDetailActions.fetchInitialData(match, {}, paginateBy));
  }

  componentDidUpdate(prevProps) {
    const { match, location } = this.props;
    const prevBooksetId = get(prevProps, 'booksetDetail.bookset.id', null);
    const isNewUrl = prevProps.match.url !== match.url;
    const paginateBy = get(match, 'path', '').indexOf('/t/') !== -1 ? paginateCountLong : paginateCountShort;
    if (prevBooksetId && prevBooksetId !== get(match, 'params.booksetId', 0) && isNewUrl) {
      this.props.BooksetDetailActions.resetData();
      this.props.BooksetDetailActions.fetchInitialData(match, location, paginateBy);
    }
  }

  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    // so we fetch data for client here
    const paginateBy = get(match, 'path', '').indexOf('/t/') !== -1 ? paginateCountLong : paginateCountShort;
    this.props.BooksetDetailActions.fetchInitialData(match, location, paginateBy);
    setTimeout(function () {
      window.dataLayer.push({ event: 'optimize.context.activate' });
    }, 0);
  }

  componentWillUnmount() {
    this.props.BooksetDetailActions.resetData();
  }

  changePage(pageNumber) {
    const { match } = this.props;

    const { top } = this.bookListRef.current.getBoundingClientRect();
    window.scrollTo(0, top);

    this.props.BooksetDetailActions.fetchBookList(match, pageNumber);
  }

  viewVersionToggler() {
    this.setState({ isDisplayLongVersion: !this.state.isDisplayLongVersion });
  }

  render() {
    const { bookset, rubrics, books, pageNumber, lastPageNumber } = this.props.booksetDetail;
    // rubrics may not be availble in bookset short resource
    const booksetRubrics = bookset && bookset.rubrics ? bookset.rubrics : [];
    const booksetName = bookset ? bookset.name : null;
    const booksetDescription = bookset ? bookset.description : null;
    const booksetBookCount = bookset ? bookset.active_book_count : null;
    const booksetPicture = bookset ? bookset.picture : null;
    const booksetSquarePicture = bookset ? bookset.preview : null;
    const authoredBy = bookset ? bookset.authored_by : null;
    const shouldShowOrder = bookset ? bookset.show_book_order : null;
    const booksetAbsoluteUrl = bookset ? bookset.absolute_url : '';
    const firstRubric = get(bookset, 'rubrics[0]', null);
    const shouldShowPaginator = lastPageNumber > 1;
    const { match } = this.props;
    const isDisplayLongVersion = get(match, 'path', '').indexOf('/t/') !== -1;

    return (
      <React.Fragment>
        <div className="section">
          <BreadCrumbs links={[
            { text: 'Подборки', url: '/sets/' },
            { text: booksetName, url: booksetAbsoluteUrl },
          ]} />
        </div>
        <div className={styles.mainPicture}>
          {(booksetPicture || booksetSquarePicture) && (
            <AdaptiveImage
              className={styles.image}
              src={{
                url: booksetSquarePicture || booksetPicture,
                width: '767',
                height: '230',
              }}
              srcSet={{
                url: booksetPicture,
                width: '1248',
                height: '374',
              }}
              media="min-width: 767px"
              alt={booksetName} />
          )}
          {authoredBy && (
            <div className={styles.booksetAuthor}>
              <BooksetAuthor {...authoredBy} />
            </div>
          )}
        </div>
        <div className="section" ref={this.bookListRef}>
          <div className={styles.contentWrapper}>
            <CatalogHeader title={booksetName} bookCount={booksetBookCount} />
            <CatalogDescription
              tags={booksetRubrics}
              description={booksetDescription} />
          </div>
          <div className={styles.separator} />
          {bookset && (
            <SocialShareMenu
              extraClassName={styles.shareMenu}
              url={bookset.share_url}
              utmCampaign="sets"
              imageUrl={bookset.picture} />
          )}
          <div ref={this.bookList}>
            {!books
              ? <BookList books={[...Array(6)]} />
              : (isDisplayLongVersion ?
                <BookList books={books} maxColumns={1} isDisplayLongVersion shouldShowOrder={shouldShowOrder} /> :
                <BookList books={books} shouldShowOrder={shouldShowOrder} />)}
          </div>
          {shouldShowPaginator && (
            <ContextPagination
              extraClassName={styles.paginator}
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          )}
          {get(rubrics, 'length', 0) > 0 && (
            <BooksetsCarousel
              title={`Другие материалы по теме «${firstRubric.name}»`}
              booksets={rubrics}
              booksetsCount={rubrics.length}
              extraClassName={shouldShowPaginator ? 'isMargined' : ''} />
          )}
        </div>
      </React.Fragment>
    );
  }
}

BooksetDetailView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      booksetId: PropTypes.string.isRequired,
    }),
  }),
};


function mapStateToProps(state) {
  return {
    booksetDetail: state.booksetDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BooksetDetailActions: bindActionCreators(BooksetDetailActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BooksetDetailView);
